/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
export const cardWidth = 600;
export const wideCardWidth = 900;
export const maxTableWidth = 1100;
export const sidebarWidth = 70;
export const dashboardVerticalPadding = 32;
export const dashboardHorizontalPadding = 42;
export const searchWidth = 400;
// this lives in Enterprise Components but is required to calculate typeahead
// result widths inside modals ):
export const defaultModalWidth = 650;
export const modalContentPadding = 32;
export const accordionMaxHeight = 200;

// Grommet components constants
export const navbarHeight = '80px';